module.exports = __webpack_public_path__ + "img/1.69dc2a49.jpg";